import { StarSecondary, StarActive, HalfFilledStar } from "components/Icons"

export default ({
  commonRate = 0,
  allowClick = false,
  handleRate = () => { },
  smaller,
}) => {
  const rateChecker = (rate, index) => {
    if (rate >= index) {
      return <StarActive smaller={smaller} />
    } else if (rate < index && rate + 1 > index) {
      return <HalfFilledStar />
    } else {
      return <StarSecondary smaller={smaller} />
    }
  }
  return (
    <div className="flex justify-center items-center">
      <div className="flex items-center">
        {Array.from({ length: 5 }).map((_, index) => (
          <button
            key={`${index + 1}`}
            className={`cursor-${allowClick ? "pointer" : "default"}`}
            disabled={!allowClick && true}
            onClick={() => {
              handleRate(++index, " ", " ", allowClick)
            }}
          >
            {rateChecker(commonRate, index + 1)}
          </button>
        ))}
      </div>
    </div>
  )
}
